export const WEEK_DAYS: { value: string; label: string }[] = [
    {
        value: 'M',
        label: 'Monday',
    },
    {
        value: 'T',
        label: 'Tuesday',
    },
    {
        value: 'W',
        label: 'Wednesday',
    },
    {
        value: 'T',
        label: 'Thursday',
    },
    {
        value: 'F',
        label: 'Friday',
    },
    {
        value: 'S',
        label: 'Saturday',
    },
    {
        value: 'S',
        label: 'Sunday',
    },
]

export const WEEK_DAYS_MILEAGE: { value: string; label: string }[] = [
    { value: 'S', label: 'Saturday' },
    { value: 'S', label: 'Sunday' },
    { value: 'M', label: 'Monday' },
    { value: 'T', label: 'Tuesday' },
    { value: 'W', label: 'Wednesday' },
    { value: 'T', label: 'Thursday' },
    { value: 'F', label: 'Friday' },
]
